import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Search2 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M12.789 3.49a6.5 6.5 0 0 1 .546 8.572l2.301 2.302a.9.9 0 1 1-1.272 1.272l-2.316-2.316a6.502 6.502 0 0 1-8.452-9.83 6.5 6.5 0 0 1 9.193 0m-7.92 1.272a4.7 4.7 0 0 0 6.21 7.034l.116-.096.724-.752.09-.117a4.7 4.7 0 0 0-.344-5.912l-.15-.157a4.7 4.7 0 0 0-6.646 0"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Search2$1 = Svg18Search2;

export { Svg18Search2$1 as default };
